import {FETCHED_SITES} from './types';
import update from 'immutability-helper/index';

const INITIAL_STATE = {
    allIncludingMaster: [],
    all: []
};

export default function(state = INITIAL_STATE, action) {
    switch(action.type) {

        case FETCHED_SITES:

            let allWithoutMaster = action.payload.filter(site => site.id !== 0);

            return update(state, {
                allIncludingMaster: {$set: action.payload},
                all: {$set: allWithoutMaster}
            });

        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/containers/sites/reducer.js